// this is an autogenerated file from App/Account/Content/Tasks/New/Content/Home/Tabs/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Content_Home_Tabs_Content($user_id: uuid!, $location_id: uuid!) {
  tasks_assignees_aggregate(
    where: {
      user_id: { _eq: $user_id }
      task: {
        stage: { done: { _eq: false } }
        board: {
          status: { _eq: active }
          metadata: { _contains: { locations: [$location_id] } }
        }
      }
    }
  ) {
    aggregate {
      count
    }
  }

  tasks_subscribers_aggregate(
    where: {
      user_id: { _eq: $user_id }
      stage: { name: { _neq: "Done" }, tasks: { _not: { assignees: {} } } }
      board: {
        status: { _eq: active }
        metadata: { _contains: { locations: [$location_id] } }
      }
    }
  ) {
    aggregate {
      count
    }
  }
}

`